import { render, staticRenderFns } from "./KaiAnswerContextMenu.vue?vue&type=template&id=3189a98d&scoped=true"
import script from "./KaiAnswerContextMenu.vue?vue&type=script&lang=js"
export * from "./KaiAnswerContextMenu.vue?vue&type=script&lang=js"
import style0 from "./KaiAnswerContextMenu.vue?vue&type=style&index=0&id=3189a98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189a98d",
  null
  
)

export default component.exports